import { utils } from '@digital-commerce/shared-utils'
import { object } from 'prop-types'
import { Spacer } from '@telus-uds/components-web'
import { ResponsiveCard } from '../StyledContainers'

import useTranslate from '../../../hooks/useTranslate'
import CartItem, { BasicInfo, ActionBar } from '../../molecules/CartItem'

const { getItemOneTimePrice, getMonthlyTotalPrice } = utils.cart

const StreamPlus = ({ streamPlusService }) => {
  const translate = useTranslate()

  const dueTodaySubTotal = getItemOneTimePrice(streamPlusService)?.subTotal ?? 0
  const monthlySubTotal = getMonthlyTotalPrice(streamPlusService)?.subTotal

  return (
    <>
      <ResponsiveCard variant={{ border: 'line', padding: 'custom' }}>
        <CartItem cartItem={streamPlusService}>
          <BasicInfo
            subHeading={translate('subHeading')}
            dueTodaySubTotal={dueTodaySubTotal}
            monthlySubTotal={monthlySubTotal}
          />
          <ActionBar isShowDetailsCtaHidden={true} isRemoveButtonHidden={false} />
        </CartItem>
      </ResponsiveCard>
      <Spacer space={5} />
    </>
  )
}

export default StreamPlus

StreamPlus.propTypes = {
  streamPlusService: object.isRequired
}
